var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"py-2 px-4 rounded shadow font-medium flex items-center justify-center",class:{
    'w-full': _vm.fullWidth,
    'bg-primary text-white': (_vm.color === 'primary'),
    'bg-secondary text-white': (_vm.color === 'secondary'),
    'bg-gray-500 text-white': (_vm.color === 'gray'),
    'bg-black text-white': (_vm.color === 'black'),
    'bg-white': (_vm.color === 'white' || _vm.outlined),
    'text-secondary border-2 border-secondary': _vm.outlined,
    'cursor-not-allowed opacity-60': _vm.disableButton,
    'transition filter hover:brightness-110': !_vm.disableButton,
    'uppercase': !_vm.noCaps,
    'rounded-full px-0 py-0': _vm.iconCircle
  },attrs:{"disabled":_vm.disableButton}},[_vm._t("prepend"),(_vm.loading)?[_c('tw-spinner',{attrs:{"size":"sm"}})]:[_vm._t("label"),_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})],_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }